module.exports = __webpack_public_path__ + "static/DeathTigerB-8c068403f7c7d1f9fdec55d1660583b1.gif";